import { render, staticRenderFns } from "./AppliancesShapesFalling.vue?vue&type=template&id=c90badc4&scoped=true&"
import script from "./AppliancesShapesFalling.vue?vue&type=script&lang=js&"
export * from "./AppliancesShapesFalling.vue?vue&type=script&lang=js&"
import style0 from "./AppliancesShapesFalling.vue?vue&type=style&index=0&id=c90badc4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c90badc4",
  null
  
)

export default component.exports